import chroma from "chroma-js";
export function transformThemePaletteToJobBoardTheme(theme) {
    var primaryColor = chroma(theme.primary);
    var primaryContentColor = chroma(theme.primaryContent).hex();
    // Only brighten really dark colors
    var primaryHoverColor = primaryColor.luminance() > 0.05
        ? primaryColor.darken(0.5).hex()
        : primaryColor.brighten(1).hex();
    var dropdownHoverColor = chroma(theme.accent).alpha(0.15).css();
    return {
        backgroundColor: "#FFFFFF",
        fontColor: "#636C74",
        focusTextColor: "#0C0D0E",
        focusBorderColor: theme.accent,
        focusBoxShadowColor: dropdownHoverColor,
        salaryBadgeTextColor: "#3B4045",
        salaryBadgeBackgroundColor: "#F1F2F3",
        companyLogoBorderColor: "#E3E6E8",
        companyLogoColor: "#FFFFFF",
        applyButtonTextColor: primaryContentColor,
        applyButtonBackgroundColor: theme.primary,
        applyButtonBackgroundHoverColor: primaryHoverColor,
        searchButtonTextColor: primaryContentColor,
        searchButtonBackgroundColor: theme.primary,
        searchButtonBackgroundHoverColor: primaryHoverColor,
        inputBorderColor: "#BABFC5",
        inputTextFocusedColor: "#0C0D0E",
        toggleCheckedBackgroundColor: theme.primary,
        dropdownBackgroundHoverColor: dropdownHoverColor,
        detailsTitleColor: "#0C0D0E",
        detailsContentBorderColor: "#E3E6E8",
        detailsCompanyNameColor: "#3B4045",
        listItemCompanyNameColor: theme.primary,
        listItemBorderActiveColor: theme.primary,
        listItemBorderInactiveColor: "#E3E6E8",
        listItemBackgroundHoverColor: "#F1F2F3",
        listItemTitleColor: "#3B4045",
        paginationButtonBorderColor: "#BABFC5",
        paginationButtonBackgroundColor: "#FFFFFF",
        paginationButtonBackgroundActiveColor: "#E3E6E8",
        paginationButtonBackgroundHoverColor: "#F1F2F3",
        autocompleteBorderColor: "#E3E6E8",
        autocompleteBackgroundColor: "#FFFFFF",
        autocompleteBackgroundHoverColor: dropdownHoverColor,
        autocompleteBackgroundFocusColor: dropdownHoverColor,
    };
}
